module.exports = __webpack_public_path__ + "img/avatar3.1f6ff8ca.png";